import { request } from '../axios/request';

import {
  FETCH_TRANSFER_ORDER_DETAIL_PENDING,
  FETCH_TRANSFER_ORDER_DETAIL_REJECTED,
  FETCH_TRANSFER_ORDER_DETAIL_FULFILLED,
} from '../constants/transferOrderDetail';

const OMS = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_TRANSFER_ORDER_DETAIL_PENDING,
});

const fulfilled = (data) => ({
  type: FETCH_TRANSFER_ORDER_DETAIL_FULFILLED,
  data,
});

const rejected = (error) => ({
  type: FETCH_TRANSFER_ORDER_DETAIL_REJECTED,
  error,
});

export const fetchTransferOrderDetail = (transferOrderId) => (dispatch) => {
  dispatch(pending());

  const url = OMS.OMS.TRANSFER_ORDER_DETAIL.replace('{0}', transferOrderId);
  request({ method: 'get', url })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};



// WEBPACK FOOTER //
// ./src/actions/transferOrderDetail.js